const FooterOurCinemasNames = [
  { name: "Dolorum optio" },
  { name: "Non rem rerum" },
  { name: "Cars fementum odio" },
  { name: "justo eget" },
  { name: "frementum iaculis" }
];

export default FooterOurCinemasNames